<template>
  <div class="zw-product-three-template">
    <!--    背景图-->
    <div
      :style="{backgroundImage:'url('+ bgImgUrl +')'}"
      class="zw-three-bg"
    >
      <div class="zw-three-bg-tile">
        <div>陕西税务12366短信平台</div>
        <span>智能网关，构建税企信息沟通桥梁</span>
      </div>
    </div>
    <div class="zw-three-bg-introduc">
      <div
        style="display: flex;justify-content: center;flex-direction: column;
        align-items: center;padding: 0 20px"
      >
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
         padding: 0 20px"
        >系统简介</div>
        <el-divider />
      </div>
      <div
        style="display: flex;padding: 50px 0 0;width: 100%;
      justify-content: center;flex-direction: column"
      >
        <div
          style="font-size: 16px;color: #000000;
        line-height: 26px"
        >
          陕西税务12366短信平台依托金税三期系统，实现了省、市、县三级税务机关的税
          法宣传、通知公告、温馨提示等短信发送服务，同时为电子税务局、纳税人学堂、门
          户网站群等系统等提供验证码实时发送，是税务机关和纳税人之家的信息沟通桥梁。
        </div>
      </div>
    </div>
    <div class="zw-three-bg-trait">
      <el-card shadow="always">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
          text-align: center;padding: 20px 0"
        >系统特点</div>
        <div class="zw-trait-context">
          <ul>
            <li v-for="(item, index) in traitList" :key="index">
              <img v-if="index!==0" src="../../assets/image/product/fgf.png" alt="">
              <div
                style="display: flex;flex-direction: column;padding: 25px 40px;
                align-items: center;color: #4c5057;height: 100%;justify-content: space-around"
              >
                <img :src="item.imgUrl" height="96px" alt="">
                <div style="text-align: center;padding-top: 30px;color: #000000">
                  {{ item.text }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-card>
    </div>
    <!--免费获取方案-->
    <div
      :style="{backgroundImage:'url('+ fontImg +')'}"
      class="zw-three-footer"
    >
      <div
        style="display: flex;align-items: center;height: 100%;
      justify-content: center;flex-direction: column"
      >
        <div style="font-size: 28px;font-weight: bold;color: #000000;padding-bottom: 30px">
          即刻为你的企业定制解决方案
        </div>
        <el-button class="depth" size="small" type="danger" @click="handleProgramme">免费获取方案</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SMSPlatform',
  data() {
    return {
      bgImgUrl: require('../../assets/image/product/threeBg.jpg'),
      fontImg: require('../../assets/image/product/threeFoot.jpg'),
      traitList: [
        {
          imgUrl: require('../../assets/image/product/three01.png'),
          text: '打造智能网关中心，实现短信分级分流；'
        },
        {
          imgUrl: require('../../assets/image/product/three02.png'),
          text: '满足省、市、县三级税务机关涉税业务；'
        },
        {
          imgUrl: require('../../assets/image/product/three03.png'),
          text: '自动加载纳税人信息，提供分类检索发送。'
        }
      ]
    }
  },
  methods: {
    // 免费获取方案
    handleProgramme() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
